<template>
  <div class="method">
    <h2>支付方式</h2>
    <method-item :value="value" data="wechat" @input="$emit('input', $event)">
      <div id="wechat" class="content">
        <i class="anyteachicon anyteach-wechat-pay" />
        <div class="text">
          <h3>微信支付</h3>
          <h4>支持零钱 / 储蓄卡 / 信用卡</h4>
        </div>
      </div>
    </method-item>
    <method-item :value="value" data="alipay" @input="$emit('input', $event)">
      <div id="alipay" class="content">
        <i class="anyteachicon anyteach-alipay" />
        <div class="text">
          <h3>支付宝</h3>
          <h4>支持花呗 / 余额宝 / 信用卡</h4>
        </div>
      </div>
    </method-item>
  </div>
</template>
<script>
import MethodItem from "./MethodItem"

export default {
  props: ["value"],
  components: { MethodItem },
}
</script>

<style lang="scss" scoped>
@import "../../../../../static/css/transaction.scss";
.method {
  h4 {
    font-size: 0.75rem;
    opacity: 0.6;
    font-weight: 400;
    margin: 0;
  }
  .content {
    display: flex;
    align-items: center;
    margin: 0 0 5px 0;

    i {
      font-size: 35px;
      line-height: 1;
      margin-right: 8px;
    }

    .text {
      h4 {
        font-size: 0.75rem;
        opacity: 0.6;
        font-weight: 400;
        margin: 0;
      }
    }
  }
  #wechat {
    i {
      color: #1ab20a;
    }
  }
  #alipay {
    i {
      color: #118ce2;
    }
  }
}
</style>